import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2 pr-md-1 pr-2" }
const _hoisted_2 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"50vw"} }
const _hoisted_3 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_4 = ["viewBox"]
const _hoisted_5 = ["xlink:href", "height", "width"]
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          "order-md": 0,
          order: 1,
          md: "7",
          cols: "12",
          class: "px-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentMenu, {
                  MenuOptions: _ctx.documentMenuOptions,
                  onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                  onZoomIn: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoomManager.zoomIn())),
                  onZoomOut: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomManager.zoomOut())),
                  onResetZoom: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomManager.resetZoom())),
                  onRotateLeft: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('left', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                  onRotateRight: _cache[5] || (_cache[5] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('right', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                  onDownload: _cache[6] || (_cache[6] = ($event: any) => (_ctx.startDownloadFile())),
                  onAnalyse: _cache[7] || (_cache[7] = ($event: any) => (_ctx.analyseDocumentDialog = true)),
                  onDelete: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteDocumentDialog = true))
                }, null, 8, ["MenuOptions"]),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    (_ctx.isPDF)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ossPdf, {
                              rotation: _ctx.documentPdfRotation,
                              documentId: _ctx.document.id
                            }, null, 8, ["rotation", "documentId"])
                          ]),
                          _: 1
                        }))
                      : (_ctx.isCSV)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                style: {"background-color":"transparent"},
                                width: "100%",
                                lines: "two"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_virtual_scroll, {
                                    "item-height": 75,
                                    items: _ctx.bankTransactions,
                                    height: "700",
                                    class: "py-3",
                                    bench: "2"
                                  }, {
                                    default: _withCtx(({ item }) => [
                                      (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: item.id,
                                        class: "oss-list-item",
                                        style: {"background":"rgb(246 246 246) !important"},
                                        active: false,
                                        link: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "10" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "d-flex pb-2 font-weight-bold align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            left: "",
                                                            color: "secondary"
                                                          }, {
                                                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                              _createTextVNode("$label")
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createElementVNode("div", _hoisted_2, _toDisplayString(item.wordingOriginal), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, {
                                                        cols: "4",
                                                        class: "px-1 d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            size: "small",
                                                            left: "",
                                                            color: "secondary"
                                                          }, {
                                                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                              _createTextVNode("$euro")
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    item.amount,
                                                                    undefined,
                                                                )), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, {
                                                        cols: "4",
                                                        class: "px-1 d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            color: "secondary",
                                                            size: "small",
                                                            location: "start"
                                                          }, {
                                                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                              _createTextVNode("$oss-calendar")
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(_toDisplayString(_ctx.formatDate(item.dateDebit)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      (item.dateRealization)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            cols: "4",
                                                            class: "px-1 d-flex align-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_icon, {
                                                                size: "small",
                                                                left: "",
                                                                color: "secondary"
                                                              }, {
                                                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                                  _createTextVNode("$fa-hourglass-half")
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.dateRealization)), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    ]),
                                    _: 1
                                  }, 8, ["items"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_ctx.document.signedUrl)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "12",
                              style: {"max-height":"85vh","overflow-y":"auto"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  (_ctx.document)
                                    ? (_openBlock(), _createElementBlock("svg", {
                                        key: 0,
                                        id: "svg-document-miscellaneous",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "100%",
                                        viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                        style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                      }, [
                                        _createElementVNode("image", {
                                          id: "svg-image-document-miscellaneous",
                                          "xlink:href": _ctx.document.signedUrl,
                                          x: "0",
                                          y: "0",
                                          height: `${_ctx.imageHeight}px`,
                                          width: `${_ctx.imageWidth}px`
                                        }, null, 8, _hoisted_5)
                                      ], 8, _hoisted_4))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "12",
                              style: {"max-height":"85vh","overflow-y":"auto","margin":"auto 0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_alert, { type: "error" }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode(" Pas de prévisualisation disponible pour ce document ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.associatedFields.show)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 0,
                  style: _normalizeStyle(_ctx.svgPosition)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `field-${_ctx.document.id}-${key}-${index}`,
                        onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                        class: "oss-list-item"
                      }, null, 8, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          "order-md": 1,
          order: 0,
          md: "5",
          cols: "12",
          class: _normalizeClass({ 'my-0 px-1': true, 'mb-3': _ctx.$vuetify.display.mobile })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: _normalizeStyle(
                        !_ctx.$vuetify.display.mobile
                            ? {
                                  'border-top-right-radius': '0px !important',
                                  'border-bottom-right-radius': '0px !important',
                              }
                            : ''
                    ),
              class: "default_card_wm fill-height elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                (_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_card_title, {
                      key: 0,
                      class: "d-flex flex-row title"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.mode !== 'GeneralLedger')
                          ? (_openBlock(), _createBlock(_component_v_btn_back, {
                              key: 0,
                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.back()), ["stop"])),
                              "data-cy": "document-back",
                              class: "mr-3"
                            }))
                          : _createCommentVNode("", true),
                        _cache[26] || (_cache[26] = _createTextVNode(" Détails du document "))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              "single-line": "",
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                _createElementVNode("b", null, "Statut", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                            _ctx.document.errorMessage &&
                                                            _ctx.reUploadDocument
                                                        )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Erreur : " + _toDisplayString(_ctx.document.errorMessage), 1))
                                                  : (_ctx.document.errorMessage)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Erreur de lecture du fichier : contacter votre cabinet "))
                                                    : (_ctx.document.type === 'UNKNOWN')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Choisissez le type du document "))
                                                      : (
                                                            _ctx.document.status === 'ORIGINAL_UPLOADED'
                                                        )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " En attente d'analyse "))
                                                        : (_ctx.document.status === 'UPLOADED')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " En attente d'analyse "))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_11, "OK"))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center align-center py-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.document.displayName,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.document.displayName) = $event)),
                              label: "Nom du document",
                              outlined: "",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_date_picker_filled, {
                              "model-value": _ctx.date,
                              onChangeDate: _ctx.onDateChanged,
                              textFieldReadOnly: false,
                              hideDetails: true,
                              label: "Date"
                            }, null, 8, ["model-value", "onChangeDate"])
                          ]),
                          _: 1
                        }),
                        (_ctx.currentUser.profile.configuration.document.write)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12",
                              class: "d-flex justify-center align-center py-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.documentType,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.documentType) = $event)),
                                  items: _ctx.documentTypes,
                                  "item-value": "value",
                                  label: "Type de document",
                                  outlined: "",
                                  "hide-details": "",
                                  density: "compact",
                                  "item-title": (item) => item.label
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                                    (_ctx.documentType === 'CURRENT_ACCOUNT' ||
                                        _ctx.documentType === 'OPERATOR_ACCOUNT') &&
                                    !_ctx.isAutonomousUser
                                )
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12",
                              class: "d-flex py-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.currentAccountUser,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentAccountUser) = $event)),
                                  items: _ctx.currentAccountUsers,
                                  "item-title": _ctx.getUserDisplayName,
                                  "item-value": "id",
                                  label: "Associé",
                                  style: {"margin":"0 auto"},
                                  "return-object": "",
                                  outlined: "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                                    _ctx.activateTagguing && _ctx.document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                )
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FreeTag, {
                                  companyTags: _ctx.allCompanyTags,
                                  document: _ctx.inDocument,
                                  splitUserPartitions: true,
                                  onChanged: _ctx.startToBeDoneIfNecessary
                                }, null, 8, ["companyTags", "document", "onChanged"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end align-center py-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              rounded: "",
                              elevation: "0",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validMiscellaneous())),
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                _createTextVNode("Enregistrer")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.mode !== 'GeneralLedger')
                  ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_dialog, {
                                  modelValue: _ctx.switchToDocumentValidationDialog,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.switchToDocumentValidationDialog) = $event)),
                                  title: "Passer à la validation",
                                  onValid: _ctx.switchToDocumentValidation,
                                  width: "40vw"
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createElementVNode("div", { class: "text-center" }, " Passer ce document en mode validation ", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "onValid"]),
                                (
                                        _ctx.documentType === 'PURCHASE_INVOICE' ||
                                        _ctx.documentType === 'SALES_INVOICE' ||
                                        _ctx.documentType === 'EXPENSE_REPORT_DOCUMENT'
                                    )
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      elevation: "0",
                                      rounded: "",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.switchToDocumentValidationDialog = true)),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                        _createTextVNode(" Passer à la validation ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_prev, {
                                  disabled: _ctx.previousDisabled(),
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.previous()))
                                }, null, 8, ["disabled"]),
                                _createVNode(_component_v_btn_next, {
                                  disabled: _ctx.nextDisabled(),
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.next()))
                                }, null, 8, ["disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_component_DocumentWizardDialog, {
      active: _ctx.activeUploadDocument,
      "onUpdate:active": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.activeUploadDocument) = $event)),
      companyId: _ctx.companyId,
      documentId: _ctx.document.id,
      documentType: _ctx.document.type,
      showFirstPrevious: false,
      multiple: false,
      onFileUploaded: _ctx.onFileUploaded
    }, null, 8, ["active", "companyId", "documentId", "documentType", "onFileUploaded"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => [
        (_ctx.editionMessage && _ctx.editionMessage.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.editionMessage
            }, null, 8, _hoisted_12))
          : _createCommentVNode("", true),
        _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1))
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.analyseDocumentDialog,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
      title: "Relancer l'analyse du document",
      onValid: _ctx.analyseDocument,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[32] || (_cache[32] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir relancer l'analyse ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 0,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          status: 'INFORMATION_REQUEST',
          showSmartChat: false
        }, null, 8, ["id"]))
      : _createCommentVNode("", true)
  ]))
}